// src/components/ListView/listSelector.js

import { createSelector } from 'reselect'
import Fuse from 'fuse.js'
import { SUCCESS } from 'utils/statusConstants'
import { getSecondaryId } from 'selectors/userpin'

export default createSelector(
  (state, { endpoint }) => state.sort[endpoint],
  state => state.search,
  (state, { loadStatus }) => loadStatus(state),
  (state, { endpoint, listState }) =>
    listState ? listState(state) : state.data[endpoint] || {},
  (_, { keys }) => keys,
  state => state.contacts.customAttributes,
  (state, { endpoint }) => endpoint,
  // this needs state of which user is selected
  // and then the ids in the data reducer
  (state, { endpoint }) =>
    endpoint === 'contact'
      ? // ? state.data?.['account/user']?.[state?.sort?.userAssignment]
        state.data?.[state.sort?.userAssignment]
      : undefined,
  state => state.sortKeys,
  state => state.userpins,
  (
    sort,
    listSearch,
    loadStatus,
    entitiesByID,
    keys,
    customAttributes,
    endpoint,
    assignedContacts,
    sortKeys,
    userpins,
  ) => {
    const sortable = keys.areFunctions
      ? Object.keys(keys.sortable)
      : keys.sortable
    const nonSortable = keys.nonSortable || []
    const entitiesArray =
      endpoint === 'contact' && assignedContacts
        ? Object.keys(assignedContacts).map(
            contactID => entitiesByID[contactID],
          )
        : Object.values(entitiesByID)

    if (loadStatus === SUCCESS || entitiesArray.length) {
      const sortFn = searchedList => {
        if (!sort) return [] // wondering if this should return searchedList instead

        const sortBy = sort.sortBy
        return searchedList.sort((a, b) => {
          const aSecondaryId = getSecondaryId(endpoint, a)
          const bSecondaryId = getSecondaryId(endpoint, b)

          const aPin = userpins[aSecondaryId]?.[a.id]
          const bPin = userpins[bSecondaryId]?.[b.id]

          // If both are pinned or both are not pinned, sort normally
          if ((aPin && bPin) || (!aPin && !bPin)) {
            const A = keys.areFunctions ? keys.sortable[sortBy](a) : a[sortBy]
            const B = keys.areFunctions ? keys.sortable[sortBy](b) : b[sortBy]
            if (A !== 0 && !A) return 1
            if (B !== 0 && !B) return -1
            if (A < B) return sort.order === 'desc' ? 1 : -1
            if (A > B) return sort.order === 'desc' ? -1 : 1
            return 0
          }

          // If only one is pinned, it should come first
          return aPin ? -1 : 1
        })
      }

      const additionalAttributes =
        endpoint === 'contact' ? customAttributes.map(ca => ca.name) : []
      const allKeys = [...sortable, ...nonSortable, ...additionalAttributes]

      if (listSearch && listSearch.length) {
        console.log('ADDITIONAL ATTRIBUTES', additionalAttributes)
        const fuse = new Fuse(entitiesArray, {
          shouldSort: true,
          threshold: 0.6,
          location: 0,
          distance: 100,
          ignoreLocation: true,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: allKeys.filter(key => {
            if (sortKeys?.[endpoint]?.[key] === false) {
              return false
            }
            return true
          }),
        })

        // This commented out code will filter out pinned items that don't match the search,
				// but it will also sort by the default sort and we don't necessarily want that,
				// since we want the most relevant information at the top:
        // const searchResults = fuse
        //   .search(listSearch)
        //   .map(entity => entitiesByID[entity.id])
        // return sortFn(searchResults)

        return fuse.search(listSearch).map(entity => entitiesByID[entity.id])
      }

      return sortFn(entitiesArray)
    }

    return []
  },
)

// non-memoized, saved for future reference

/* export default (state, { endpoint, listState, loadStatus, keys }) => {
  const sort = state.sort[endpoint]
  const listSearch = state.search
  const entitiesByID = listState ? listState(state) : state.data[endpoint] || {}
  const customAttributes = state.contacts.customAttributes
  const assignedContacts =
    endpoint === 'contact'
      ? state.data?.[state.sort?.userAssignment]
      : undefined

  const sortable = keys.areFunctions
    ? Object.keys(keys.sortable)
    : keys.sortable
  const nonSortable = keys.nonSortable || []
  const entitiesArray =
    endpoint === 'contact' && assignedContacts
      ? Object.keys(assignedContacts).map(contactID => entitiesByID[contactID])
      : Object.values(entitiesByID)

  if (loadStatus === SUCCESS || entitiesArray.length) {
    const sortFn = searchedList => {
      if (!sort) return []

      const sortBy = sort.sortBy
      return searchedList.sort((a, b) => {
        const A = keys.areFunctions ? keys.sortable[sortBy](a) : a[sortBy]
        const B = keys.areFunctions ? keys.sortable[sortBy](b) : b[sortBy]
        if (A !== 0 && !A) return 1
        if (B !== 0 && !B) return -1
        if (A < B) return sort.order === 'desc' ? 1 : -1
        if (A > B) return sort.order === 'desc' ? -1 : 1
        return 0
      })
    }

    if (listSearch && listSearch.length) {
      const additionalAttributes =
        endpoint === 'contact' ? customAttributes.map(ca => ca.name) : []
      console.log('ADDITIONAL ATTRIBUTES', additionalAttributes)
      const fuse = new Fuse(entitiesArray, {
        shouldSort: true,
        threshold: 0,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [...sortable, ...nonSortable, ...additionalAttributes],
      })

      return fuse.search(listSearch).map(entity => entitiesByID[entity.id])
    }

    return sortFn(entitiesArray)
  }

  return []
} */
